import React from 'react';
import { useLocation } from 'react-router-dom';

import DefaultLayout from '../../_layouts/default';

import DataLoad from './DataLoad';
import List from './List';
import Record from './Record';
import View from './View';

const RebateBalQuarters: React.FC = () => {
  const { pathname } = useLocation();

  const getComponent = (): React.ReactNode => {
    if (pathname === '/configurations/rebatebalancequarters/dataload') {
      return <DataLoad />;
    }

    if (pathname === '/configurations/rebatebalancequarters/record') {
      return <Record />;
    }

    if (pathname === '/configurations/rebatebalancequarters/view') {
      return <View />;
    }

    return <List />;
  };

  return <DefaultLayout>{getComponent()}</DefaultLayout>;
};

export default RebateBalQuarters;
